import { faEye } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CircularProgress, Typography } from "@mui/material"
import { translate } from "app/language/service"
import { IOrder } from "order/model"
import { getOrderCampaignCount } from "order/tools/campaign"
import React from "react"

interface IOrderCampaignsCellProps {
  order: IOrder
  onClick: (order: IOrder) => any
}

export const OrderCampaignsCell = React.memo(({ order, onClick }: IOrderCampaignsCellProps): JSX.Element => {
  const [campaignCount, setCampaignCount] = React.useState<null | number>(null) // -1 mean an error occured
  // first render use effect
  React.useEffect(() => {
    getOrderCampaignCount(order.id)
      .then(count => setCampaignCount(count))
      .catch(error => {
        console.error("Unable to get order campaigns count", error)
        setCampaignCount(-1)
      })
  }, [])
  if (campaignCount === -1) {
    return (
      <Typography color="error" fontSize=".9rem">
        {translate("label.error.unexpected")}
      </Typography>
    )
  }
  if (campaignCount === null) {
    return <CircularProgress size="1rem" />
  }
  return (
    <Typography
      color="textPrimary"
      fontSize=".9rem"
      onClick={campaignCount === 0 ? undefined : () => onClick(order)}
      sx={{
        "& .icon": { ml: ".5rem", color: theme => theme.palette.secondary.main },
        "& .icon:hover": { cursor: "pointer", color: theme => theme.palette.primary.main }
      }}>
      {campaignCount}
      {campaignCount > 0 && <FontAwesomeIcon icon={faEye} size="1x" className="icon" />}
    </Typography>
  )
})
